// extracted by mini-css-extract-plugin
export var heading = "Refer-module__heading___UmDNW";
export var link = "Refer-module__link___Xyzij";
export var fields = "Refer-module__fields___FweIX";
export var invite = "Refer-module__invite___LxGLS";
export var yourInvites = "Refer-module__yourInvites___HxriO";
export var terms = "Refer-module__terms___wjlH0";
export var content = "Refer-module__content___vvMCY";
export var title = "Refer-module__title___nmdf0";